import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import DataTable from "common/Tables/DataTable";
import dealersTableData from "layouts/tables/data/dealersTableData";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDealers } from "store/slice/dealersSlice";
import { useNavigate } from "react-router-dom";
import { getGames } from "store/slice/gamesSlice";
import { deleteDealer } from "store/slice/dealersSlice";
import { Dialog, DialogContent } from "@mui/material";
import Button from "@mui/material/Button"; 

function Dealers() {
    const [search, setSearch] = useState("");
    const dealers = useSelector(store => store.dealers);
    const [pageSize, setPageSize] = useState(100);
    const [openImage, setOpenImage] = useState(null); // store clicked image

    const handleImageClick = (image) => setOpenImage(image);
    const handleClose = () => setOpenImage(null);

    const editAction = (dealer) => {
      navigate(`/dealers/${dealer.id}`)
    }

    const deletAction = (dealer) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this dealer?");
        if (confirmDelete) {
            dispatch(deleteDealer(dealer.id));
            navigate("/dealers"); 
        }
    };

    const { columns, rows: initialRows, modal } = dealersTableData({dealers: dealers.dealers, editAction, deletAction, onImageClick: handleImageClick});
    // const [filteredRows, setFilteredRows] = useState(initialRows);
    // useEffect(() => {
    //   setFilteredRows(initialRows)
    // }, [initialRows.length])
    
    const navigate = useNavigate();
    
    const dispatch = useDispatch();

    const filteredRows = useMemo(() => {
      const q = search.trim().toLowerCase();
      if (!q) return initialRows;
      return initialRows;
      return initialRows.filter((row) =>
        (row.dealerText ?? "").toLowerCase().includes(q)
      );
    }, [search, initialRows]);

    useEffect(() => {
        dispatch(getDealers())
        dispatch(getGames())
    }, [dispatch]);


    const handleSearch = useCallback((value) => {
      console.log("handleSearch called:", value);
     setSearch((prev) => (prev === value ? prev : value));
    }, []);

  const handleAddDealer = () => {
    navigate("/dealers/new"); // Navigate to the page to create a new game
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item size={{xs: 12}}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Dealers
                </MDTypography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddDealer} 
                >
                  Add Dealer
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows: filteredRows }}
                  isSorted={true}
                  searchResult={handleSearch}
                  canSearch={true}
                  entriesPerPage={{ defaultValue: pageSize, entries: [5, 10, 15, 20, 25, 100] }}
                  showTotalEntries={true}
                  noEndBorder
                />
                <Dialog open={!!openImage} onClose={handleClose} maxWidth="sm">
                  <DialogContent sx={{ p: 0 }}>
                    {openImage && (
                      <img
                        src={openImage}
                        alt="Dealer"
                        style={{ width: "100%", height: "auto", borderRadius: "8px", display: "block" }}
                      />
                    )}
                  </DialogContent>
              </Dialog>
              </MDBox>
            </Card>
          </Grid>
        
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dealers;
